export const ADDRESS_MODAL_WIDTH_DESKTOP = '600px';
export const ADDRESS_MODAL_MAX_WIDTH_DESKTOP = '800px';
export const MAX_PHONE_LENGTH = 15;
export const MAX_UNIT_LENGTH = 20;
export const MAX_INSTRUCTIONS_LENGTH = 200;

export const PHONE_REGEX = /^\+?\d{0,15}$/;
export const SUBMIT_PHONE_REGEX = /^\+?\d{10,15}$/;
export const UNIT_REGEX = /^[a-zA-Z0-9\s#\-\/]*$/;
export const INSTRUCTION_SAFE_REGEX = /^[a-zA-Z0-9\s.,'\/\-()&!?]*$/;
